import { render, staticRenderFns } from "./common-canvas-record.vue?vue&type=template&id=e789c96e&scoped=true&"
import script from "./common-canvas-record.vue?vue&type=script&lang=js&"
export * from "./common-canvas-record.vue?vue&type=script&lang=js&"
import style0 from "./common-canvas-record.vue?vue&type=style&index=0&id=e789c96e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e789c96e",
  null
  
)

export default component.exports